import React, { useEffect, useState } from "react";
import Sidemenu from '../base/sidemenu';
import { useParams, useNavigate } from "react-router-dom";
import { fetchQnaDetail, postQnaReply } from "../../services/AdminQnaService";

export default function AdminQnaDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [qnaDetail, setQnaDetail] = useState(null);
  const [reply, setReply] = useState("");

  // 🔹 문의사항 상세 불러오기
 // 🔹 문의사항 상세 불러오기
useEffect(() => {
  const getDetail = async () => {
    try {
      const data = await fetchQnaDetail(id, token);
      console.log("상세 데이터:", data);
      if (data.success) {
        // ✅ replies는 data.replies 에서 가져오기
        setQnaDetail({
          ...data.qna_detail,
          replies: data.replies || []
        });
      } else {
        alert("문의 상세 데이터를 불러올 수 없습니다.");
      }
    } catch (err) {
      console.error("상세보기 실패:", err);
    }
  };
  getDetail();
}, [id, token]);


  // 🔹 답변 등록
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reply.trim()) {
      alert("답변 내용을 입력해주세요.");
      return;
    }

    try {
      const data = await postQnaReply(Number(id), reply, token);
      console.log("서버 응답:", data);

      if (data.success) {
        alert("답변이 등록되었습니다!");
        // 답변 배열에 바로 추가
        setQnaDetail({
          ...qnaDetail,
          replies: [
            ...(qnaDetail.replies || []),
            {
              id: data.reply_id,
              content: reply,
              user_name: "관리자", // 필요시 서버에서 내려오는 작성자 이름 사용
              create_date: new Date().toISOString(),
            },
          ],
        });
        setReply(""); // 입력창 초기화
      } else {
        alert("답변 등록 실패: " + (data.message || ""));
      }
    } catch (err) {
      console.error("답변 등록 실패:", err.response?.data || err);
      console.log("보내는 데이터:", { id: Number(id), content: reply });
      console.log("토큰:", token);
      alert("서버와 통신 중 오류가 발생했습니다. 콘솔 확인");
    }
  };

  if (!qnaDetail) return <p>문의 정보를 불러오는 중...</p>;

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="admin">
        <h1>문의사항 상세보기</h1>

        <div className="admin_box">
          <div className="admin_qna_detail">
            <h2>{qnaDetail.title}</h2>
            <ul>
              <li><strong>작성자</strong> · {qnaDetail.name || "알 수 없음"}</li>
              <li><strong>작성일</strong> · {new Date(qnaDetail.create_date).toLocaleString()}</li>
            </ul>

            <div className="qna_content_box">
              <strong>내용</strong>
              <p>{qnaDetail.content}</p>
            </div>

            <hr />

            {/* 🔹 기존 답변 목록 */}
            <div className="qna_replies">
              <h3>답변 목록</h3>
              {qnaDetail.replies.length > 0 ? (
                qnaDetail.replies.map((r) => (
                  <div key={r.id} className="reply_box">
                    <p className="replies_name"><strong>작성자:</strong> {r.user_name || "관리자"}</p>
                    <p className="replice_txt">{r.content}</p>
                    <p className="date">{new Date(r.create_date).toLocaleString()}</p>
                  </div>
                ))
              ) : (
                <p>등록된 답변이 없습니다.</p>
              )}
            </div>

            <hr />

            {/* 🔹 답변 작성 폼 */}
            <form onSubmit={handleSubmit}>
              <label className="adqnatit">답변 작성</label>
              <textarea
                value={reply}
                onChange={(e) => setReply(e.target.value)}
                placeholder="답변 내용을 입력하세요."
                rows="5"
                required
              />
              <p className="qnabutton"><button type="submit">답변등록</button></p>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
}
